/**
 * ATL-1445 — the one call New Sale and the acceptance form make after their own writer saved a
 * record from an API draft. Never throws and is never awaited by the save: the record is saved
 * either way, and the report's fate is kept on the device (apiDraftReports.ts) for the inbox.
 *
 * What the merchant is told: nothing when the backend recorded it or will be retried (the inbox
 * shows "saved, confirming" until it lands); the reason when the backend refused to link it, because
 * then the record exists but the draft does not say so — a second tap would be a second record.
 */
import * as Sentry from '@sentry/react-native'
import type { ApiDraft } from './apiDraftsApi'
import { deviceDraftReports, type ReportOutcome } from './apiDraftReports'

export function reportApiDraftSaved({
  draft,
  organizationId,
  firestoreId,
  onRefused,
}: {
  draft: Pick<ApiDraft, 'id' | 'kind'>
  /** The organization (Firestore id) the record was saved in. */
  organizationId: string
  firestoreId: string
  onRefused: (code: string) => void
}): Promise<ReportOutcome | null> {
  return deviceDraftReports.saved({ id: draft.id, kind: draft.kind, organizationId }, firestoreId).then(
    (result) => {
      if (result.outcome === 'refused') onRefused(result.code)
      return result
    },
    (error: unknown) => {
      // Only the device store can throw here (the report itself is classified, never thrown).
      Sentry.captureException(error, {
        level: 'warning',
        tags: { feature: 'api-draft' },
        extra: { draftId: draft.id, kind: draft.kind, firestoreId },
      })
      return null
    }
  )
}
